<div class="content">
    <div class="slider-container">
        <div class="slider-label" trans>Opacity</div>
        <mat-slider min="0.1" max="1" step="0.1" (input)="setValue('opacity', $event.value)" [formControl]="activeObject.getControl('opacity')"></mat-slider>
    </div>
</div>